export const  wordpressUrl = 'https://www.whitefieldindia.com/server/';